import { configureSentry } from './sentry'

const bodyElement = document.querySelector('body')
if (bodyElement && bodyElement.dataset.sentry) {
  try {
    const options = JSON.parse(bodyElement.dataset.sentry)
    configureSentry(options)
  } catch (error) {
    console.error(error)
  }
}

import './core/components/Base'
import './core/components/Navigation'
import './core/components/SiteHeader'
import './core/components/SiteFooter'

import "./core/components/View"
import "./core/components/Forms"
import "./core/components/Guide"
import "./core/components/Wysiwyg"

import './apps/Landing'
import './apps/Accounts'
import './apps/Billing'

